// extracted by mini-css-extract-plugin
export var standaloneTable = "_gg-0";
export var standaloneTableWithBodyFill = "_gg-1";
export var withExtraHeader = "_gg-2";